export default __webpack_public_path__ + "static/taskdefinition16-46cf184ac5eb52779a2fd5a359f887eb.png";